import { environmentConfig } from "../appV2/environment";

/**
 * @deprecated Use environmentConfig from src/appV2/environment/config.ts
 */
const meta = () => {
  const app = {
    dev: "localhost:3000",
    demo: "demo.clipboardhealth.com",
    ops: "ops.clipboardhealth.com",
    sandbox: "app-sandbox.clipboardhealth.com",
    staging: "app-staging.getbluebirdhealth.com",
    production: "clipboard.health",
  };

  const commonOptions = {
    appEnv: environmentConfig.REACT_APP_ENVIRONMENT_NAME,
    shiftSign: true,
    supportPhone: "408-837-0116",
    supportEmail: "support@clipboardhealth.com",
    uspSmsLine: "(510)405-1047",
    zenDeskContact: "https://app.futuresimple.com/crm/contacts",
    googleStreetMapViewApiUrl: "https://maps.googleapis.com/maps/api/streetview",
    workerDocsLink: "https://cbh.care/docs",
    workerOpenShiftsLink: "https://cbh.care/openShifts",
    workerWebApp: "https://hcp.clipboard.health",
    firebaseConfig: {
      apiKey: "AIzaSyC8W_0rbJCPhUHl0pf0XkWC59R4eHGpSmA",
      authDomain: "clipboard-app.firebaseapp.com",
      databaseURL: "https://clipboard-app.firebaseio.com",
      projectId: "clipboard-app",
      storageBucket: "clipboard-app.appspot.com",
      messagingSenderId: "651599910014",
      appId: "1:651599910014:web:1690f2328ca70ced14342f",
      measurementId: "G-EFPXTPH5QT",
    },
    baseChargeLimit: {
      CNA: 70,
      LVN: 90,
      RN: 145,
      CAREGIVER: 70,
      NP: 110,
      "Medical Technician": 70,
    },
    zendeskWebWidgetId: "ze-snippet",
    maxShiftDuration: 17,
    minShiftDuration: 0.5,
    apiMainUrl: environmentConfig.REACT_APP_API_MAIN_URL,
    documentServiceUrl: environmentConfig.REACT_APP_DOCUMENTS_SERVICE_URL,
    documentServiceRestApiUrl: environmentConfig.REACT_APP_DOCUMENTS_SERVICE_REST_API_URL,
    homeHealthApiUrl: environmentConfig.REACT_APP_HOME_HEALTH_API_URL,
    workerServiceUrl: environmentConfig.REACT_APP_WORKER_SERVICE_URL,
    shiftVerificationBaseUrl: environmentConfig.REACT_APP_SHIFT_VERIFICATION_BASE_URL,
    sendBirdAppId: environmentConfig.REACT_APP_SENDBIRD_APP_ID,
    licenseManagerServiceUrl: environmentConfig.REACT_APP_LICENSE_MANAGER_SERVICE_URL,
    attendanceScoreServiceUrl: environmentConfig.REACT_APP_ATTENDANCE_SCORE_SERVICE_URL,
    facilitySupportArticlesLink: environmentConfig.REACT_APP_FACILITY_SUPPORT_ARTICLES_LINK,
    workerReviewServiceUrl: environmentConfig.REACT_APP_SHIFT_REVIEW_API_URL,
    useDeprecatedWorkers: environmentConfig.REACT_APP_USE_DEPRECATED_WORKERS,
    brazeSdkEndpoint: environmentConfig.REACT_APP_ADMIN_HCF_WEB_BRAZE_SDK_ENDPOINT,
    brazeKey: environmentConfig.REACT_APP_ADMIN_HCF_WEB_BRAZE_KEY,
    brazeSafariId: environmentConfig.REACT_APP_ADMIN_HCF_WEB_BRAZE_SAFARI_ID,
    jwtMicroserviceBaseUrl: environmentConfig.REACT_APP_ZENDESK_JWT_MICROSERVICE_BASE_URL,
    workerEtaApi: environmentConfig.REACT_APP_WORKER_ETA_API,
    launchDarklyClientSideId: environmentConfig.REACT_APP_LAUNCH_DARKLY_CLIENT_SIDE_ID,
    paymentsApiUrl: environmentConfig.REACT_APP_PAYMENTS_API_URL,
    zendeskMessagingWidgetUrl: environmentConfig.REACT_APP_ZENDESK_MESSAGING_WIDGET_URL,
    muiLicenseKey: environmentConfig.REACT_APP_MUI_LICENSE_KEY,
    adminClientUrl: environmentConfig.REACT_APP_ADMIN_APP_CLIENT_URL,
    googleMapApi: environmentConfig.REACT_APP_GOOGLE_MAP_API,
  };

  const segment = {
    dev: {
      key: "e369WCLzzXytmMeSPHGMo0PARzFyBcX0",
    },
    sandbox: {
      key: "e369WCLzzXytmMeSPHGMo0PARzFyBcX0",
    },
    production: {
      key: "WBGrMGAgWwplwULUnWxSFLoorUM4JkH7",
    },
  };

  const PRODUCTION_HOSTS = [
    "beta.clipboard.health",
    "backup1.clipboard.health",
    "backup2.clipboard.health",
    "clipboard.health",
  ];

  const locationHost = window.location.host;

  const host = PRODUCTION_HOSTS.includes(locationHost) ? app.production : locationHost;
  const stage = app.dev ? "dev" : app.sandbox ? "sandbox" : undefined;

  switch (host) {
    case app.dev:
      return {
        api: environmentConfig.REACT_APP_BASE_API_URL,
        app: app.dev,
        ...commonOptions,
        documentServiceUrl: commonOptions.documentServiceUrl,
        stage,
        segment: segment.dev,
        zendeskFrameAncestorOrigin: "https://970533.apps.zdusercontent.com",
      };
    case app.sandbox:
      return {
        api: "/api",
        app: app.sandbox,
        ...commonOptions,
        stage,
        segment: segment.sandbox,
        zendeskFrameAncestorOrigin: "https://970533.apps.zdusercontent.com",
      };
    case app.demo:
      return {
        api: "/api",
        app: app.demo,
        ...commonOptions,
        stage,
        segment: segment.sandbox,
        zendeskFrameAncestorOrigin: "https://970533.apps.zdusercontent.com",
      };
    case app.ops:
      return {
        api: "/api",
        app: app.ops,
        ...commonOptions,
        stage,
        segment: segment.sandbox,
        zendeskFrameAncestorOrigin: "https://970533.apps.zdusercontent.com",
      };
    case app.staging:
      return {
        api: "/api",
        app: app.staging,
        ...commonOptions,
        stage,
        segment: segment.sandbox,
        zendeskFrameAncestorOrigin: "https://970533.apps.zdusercontent.com",
      };
    case app.production:
      return {
        api: locationHost === app.production ? environmentConfig.REACT_APP_BASE_API_URL : "/api",
        app: app.production,
        ...commonOptions,
        firebaseConfig: {
          apiKey: "AIzaSyA3PoA1BjIP1TGD4GiHZsBSOMqHeXE5HYE",
          authDomain: "clipboard-health.firebaseapp.com",
          databaseURL: "https://clipboard-health.firebaseio.com",
          projectId: "clipboard-health",
          storageBucket: "clipboard-health.appspot.com",
          messagingSenderId: "1098403931480",
          appId: "1:1098403931480:web:cf36f44ee505ab81",
          measurementId: "G-K65B9132JS",
        },
        stage,
        documentServiceUrl: environmentConfig.REACT_APP_DOCUMENTS_SERVICE_URL,
        segment: segment.production,
        zendeskFrameAncestorOrigin: "https://989425.apps.zdusercontent.com",
      };
    default:
      return {
        api: commonOptions.apiMainUrl + "/api",
        app: "",
        ...commonOptions,
        stage,
        segment: segment.sandbox,
        zendeskFrameAncestorOrigin: "https://970533.apps.zdusercontent.com",
      };
  }
};

export default meta;
